import instance from './axiosInstance';

function getMetricsData(reqBody, options = {}, http = instance) {
  return http.post('/metrics', reqBody, options);
}

function getDistributionData(reqBody, options = {}, http = instance) {
  return http.post('/metrics/distribution', reqBody, options);
}

function getRealtimeData(reqBody, options = {}, http = instance) {
  return http.post('/realtime', reqBody, options);
}

function getThresholdData(reqBody, options = {}, http = instance) {
  return http.post('/realtime/threshold', reqBody, options);
}

function updateThresholdData(reqBody, options = {}, http = instance) {
  return http.post('/realtime/threshold/update', reqBody, options);
}

function updateThresholdDisabledStatus(reqBody, options = {}, http = instance) {
  return http.post('/feature_flags/update', reqBody, options);
}

function getAdTimeseriesData(reqBody, options = {}, http = instance) {
  return http.post('/timeseries', reqBody, options);
}

export default getMetricsData;

export {
  getDistributionData,
  getRealtimeData,
  getThresholdData,
  updateThresholdData,
  updateThresholdDisabledStatus,
  getAdTimeseriesData,
};
